import { render, staticRenderFns } from "./DashBoardSelfObjectives.vue?vue&type=template&id=2c64a5bb&scoped=true&"
import script from "./DashBoardSelfObjectives.vue?vue&type=script&lang=js&"
export * from "./DashBoardSelfObjectives.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardSelfObjectives.vue?vue&type=style&index=0&id=2c64a5bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64a5bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VHover,VIcon,VProgressLinear,VRow})
